<template>
  <div>
    <el-table
    v-loading="listLoading"
    height="750"
    :data="list"
    element-loading-text="Loading"
    border
    fit
    highlight-current-row
    >
    <el-table-column align="center" width="60" label="编号" >
        <template slot-scope="scope">
        {{ pageSize *( pageIndex - 1) + ( scope.$index + 1 )}}
        </template>
    </el-table-column>

    <el-table-column class-name="status-col" label="发放前金额"  align="center">
        <template slot-scope="scope">
          {{ scope.row.frontAmount }}
        </template>
    </el-table-column>

    <el-table-column label="发放金额"  align="center">
        <template slot-scope="scope">
          {{ scope.row.amount }}
        </template>
    </el-table-column>

    <el-table-column class-name="status-col" label="发放后金额"  align="center">
        <template slot-scope="scope">
          {{ scope.row.backAmout || 0}}
        </template>
    </el-table-column>

   

    <el-table-column label="分销比例"  align="center"> 
        <template slot-scope="scope">
        {{ scope.row.mutilLevelRate }}
        </template>
    </el-table-column>

    <el-table-column label="角色比例" align="center">
        <template slot-scope="scope">
          {{ scope.row.roleRate }}
        </template>
    </el-table-column>

    <el-table-column label="交易订单号" align="center">
        <template slot-scope="scope">
          {{ scope.row.tradeNo }}
        </template>
    </el-table-column>

    

    <el-table-column class-name="status-col" label="创建时间" align="center">
        <template slot-scope="scope">
         <div>{{ scope.row.creationTime }}</div>
        </template>
    </el-table-column>

    <el-table-column class-name="status-col" label="修改时间" align="center">
        <template slot-scope="scope">
         <div>{{ scope.row.updationTime }}</div>
        </template>
    </el-table-column>

    </el-table>
    <!-- 分页 -->
    <Pagination ref="Pagination" />
  </div>
</template>

<script>
import { lookYetBonusApi } from '@/api/money.js'
import Pagination from '@/components/Pagination' // 分页
import { mapGetters } from 'vuex'
export default {
  components: {
    Pagination
  },
  data () {
    return {
      list: null,
      listLoading: false,
      pageSize: 0,
      pageIndex: 0
    }
  },
  mounted () {
    let bonusId = this.$route.query.id || ''
    this.fetchData(bonusId)
  },
  computed: {
    ...mapGetters([
      'paginObj'
    ])
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    'paginObj': 'fetchData'
  },
  methods: {
    // 请求表单数据
   async fetchData (bonusId ) {
     try {
       if(bonusId === '') return
        this.listLoading = true
        let res = await lookYetBonusApi({ 
          bonusId,
          pageSize: this.paginObj.pageSize, 
          pageIndex: this.paginObj.pageIndex,
        })
        let { pageSize, pageIndex, dataList, totalCount } = res.data
        this.list = dataList
        this.listLoading = false
        this.pageSize = pageSize
        this.pageIndex = pageIndex
        this.$refs.Pagination.pageSize = pageSize
        this.$refs.Pagination.pageIndex = pageIndex
        this.$refs.Pagination.totalCount = totalCount
     } catch (e) {
       window.console.log(e)
     }
    }
  }
}
</script>

<style lang="less" scoped>

.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
    margin-left: 10px;
}
</style>
